"use strict";

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

exports.implementation = function Plugin() {
  _classCallCheck(this, Plugin);
};